import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {WidgetDialogService} from '../../../services/widget-dialog.service';
import {TranslateService} from '@ngx-translate/core';
import {WidgetDpiaV0Header, WidgetDpiaV0Preview} from './models/widget-dpia-v0-preview';
import {WidgetDpiaV0Value, WidgetDpiaV0ValueData} from './models/widget-dpia-v0-value';
import {WidgetDpiaV0QueryResponseDemage, WidgetDpiaV0QueryResponseThreat} from './models/widget-dpia-v0-query-response';
import {WidgetDpiaV0DataGravityValues} from './models/widget-dpia-v0-data';
import {DamageTypeEnum, ND, REQUIRED_VALIDATOR_KEY} from '@pt/pt-models';
import {ValidatorGenerator} from '../../../utils';
import {InputRadioData} from '../../../components';

@Component({
  selector: 'pt-widget-dpia-v0-edit',
  template: `
    <div *ngIf='show && !loading'>
      <pt-input-radio
        class="damage-type-radio"
        [validators]='[REQUIRED]'
        [disabled]="preview || showConfirmChange"
        [(ngModel)]="currentDamageType"
        (ngModelChange)="changeDamageType($event)"
        [options]='typeOptions'
      ></pt-input-radio>

      <div class='treatmentRiskFactors' (click)='$event.stopPropagation()'>
        <div class='me-2'>{{ 'LABELS.RISK_FACTOR' | translate }}:</div>
        <div [class]='getRiskFactorColor(treatmentRiskFactors)'>
          {{ showRiskFactor(treatmentRiskFactors) ? treatmentRiskFactors : ND }}
        </div>
      </div>

      <div *ngIf="showConfirmChange" class="damage-type-action">
        <div class="warning-message" *ngIf="!invalidDamageTypeSelected"
             [innerHTML]="'MESSAGE.CHANGE_DAMAGE_TYPE' | translate"></div>
        <div class="warning-message" *ngIf="invalidDamageTypeSelected"
             [innerHTML]="'MESSAGE.INVALID_DAMAGE_TYPE' | translate"></div>
        <button class="btn btn-primary btn-sm ms-2"
                *ngIf="currentDamageType  "
                [disabled]="invalidDamageTypeSelected"
                (click)="changeDamageTypeConfirmed()">{{ 'BUTTON.CONFIRM' | translate }}
        </button>
        <button class="btn btn-outline-secondary btn-sm ms-2"
                (click)="changeDamageTypeCancel()">{{ 'BUTTON.CANCEL' | translate }}
        </button>
      </div>

      <ng-container *ngIf="savedDamageType">
        <div class='table-responsive'>
          <table class='table table-striped table-sm'>
            <thead>
            <tr>
              <th scope='col' class='border-0' style="min-width: 100px"></th>
              <th scope='col' class='border-0' style="min-width: 65px"></th>
              <th scope='col' [colSpan]='editorData?.queryResponse?.threat?.length'
                  class='widget-dpia-damage-col text-center'>{{ header?.threat }}
              </th>
            </tr>
            <tr>
              <th scope='col'
                  class='widget-dpia-threat-col'>
                {{ header?.damage }}
              </th>
              <th scope='col'
                  class='widget-dpia-threat-col'>
                {{ header?.type }}
              </th>
              <th class='widget-dpia-threat-col--min-width'
                  *ngFor='let threat of editorData?.queryResponse?.threat'>
                <div class='cell primary-label'>
                  {{ threat.label }}
                </div>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor='let row of demageTableRow'>
              <td class='widget-dpia-tbody-head'>
                <div class='primary-label'>{{ row.demage.label }}</div>
              </td>
              <td>
                <div class='primary-label'>{{ row.demage.category }}</div>
              </td>
              <td *ngFor='let col of row.col' class='widget-dpia-tbody-col'>
                <pt-widget-dpia-v0-gravity-value-selector
                  *ngIf='!preview && !showConfirmChange && savedDamageType'
                  [options]='editorData.data.gravityValues'
                  [value]='col.gravityValue'
                  (changeValue)='changeCellValue(col, $event)'>
                </pt-widget-dpia-v0-gravity-value-selector>

                <span class='widget-dpia-value-preview' [ngStyle]='{"border-color": getColor(col.gravityValue)}'
                      *ngIf='preview || showConfirmChange || !savedDamageType'>
                {{ getGravityValue(col.gravityValue)?.label }}
              </span>
              </td>
            </tr>
            <tr *ngIf='demageTableRow?.length === 0'>
              <td>{{ 'MESSAGE.NO_DEMAGE' | translate }}</td>
              <td *ngFor='let threat of editorData?.queryResponse?.threat'>
                {{ ND }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class='widget-dpia-note-title'>
          {{ 'LABELS.NOTE' | translate }}
        </div>
        <div
          (click)='openTextArea(currentNote)'
          class='widget-dpia-note'
          [innerHTML]="currentNote | formatText ">
        </div>
      </ng-container>

    </div>
  `,
  styles: [`
    .treatmentRiskFactors {
      font-style: italic;
      color: var(--bs-secondary);
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
    }

    .damage-type-radio {
      display: flex;
      width: 100%;
      margin-bottom: 5px;
    }

    .damage-type-action {
      display: flex;
      margin-bottom: 10px;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .warning-message {
        background: #ffc107ad;
        font-weight: 100;
        text-align: center;
        font-size: 13px;
        color: #140e0e;
        margin-right: auto;
        padding: 0 5px;
      }
    }

    .primary-label {
      color: var(--bs-dark);
      font-size: 12px;
    }

    .secondary-label {
      color: var(--bs-gray);
      font-size: 10px;
    }

    .widget-dpia-value-preview {
      border: solid 2px black;
      border-radius: 6px;
      display: block;
      text-align: center;
      font-size: 11px;
      padding: 5px;
    }

    .widget-dpia-damage-col {
      /*border: 1px solid #ce1115;*/
      /*color: #ce1115;*/
      background: #33333333;
      color: #333333;
      vertical-align: middle;
    }

    .widget-dpia-threat-col {
      border-top: 1px solid #33333333;
      color: #333333;
      /*color: #E04500;*/
      vertical-align: middle;
    }

    .widget-dpia-threat-col--min-width {
      min-width: 84px; /* prima era 100px;*/
      vertical-align: middle;
    }

    .widget-dpia-tbody-head {
      min-width: 100px;
    }

    .widget-dpia-tbody-col {
      padding: 0 4px;
      vertical-align: middle;
      font-size: 10px;
      width: 180px;
    }

    .widget-dpia-note-title {
      font-size: 12px;
      margin-top: 10px;
    }

    .widget-dpia-note {
      min-width: 150px;
      max-height: 100px;
      min-height: 50px;
      overflow-y: auto;
      font-size: 12px;
      cursor: pointer;
      position: relative;
      border: 1px solid #bbbbbb;
      padding: 5px;
    }
  `]
})
export class WidgetDpiaV0EditComponent implements OnChanges {
  @Input() show: boolean;
  @Input() editorData: WidgetDpiaV0Preview;
  @Input() preview: boolean;
  @Input() treatmentRiskFactors: number;
  @Output() changeValue = new EventEmitter<WidgetDpiaV0Value>();

  invalidDamageTypeSelected = false;
  savedDamageType?: DamageTypeEnum
  currentDamageType?: DamageTypeEnum;
  currentEditorData: WidgetDpiaV0Preview;

  REQUIRED = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  typeOptions: InputRadioData[] = [
    {
      label: this.translateService.stream('LABELS.DPIA_OBLIGATORY'),
      value: DamageTypeEnum.DPIA
    },
    {
      label: this.translateService.stream('LABELS.DPIA_SIMPLIFIED'),
      value: DamageTypeEnum.DPIA_SIMPLIFIED
    }
  ];

  ND = ND;

  loading: boolean;

  header: WidgetDpiaV0Header;

  value: WidgetDpiaV0Value;
  threat: WidgetDpiaV0QueryResponseThreat[];   // COL
  demage: WidgetDpiaV0QueryResponseDemage[]; // ROW
  currentNote: string;
  demageTableRow: DemageRow[];
  showConfirmChange = false;

  constructor(private widgetDialogService: WidgetDialogService, private translateService: TranslateService) {
  }

  getGravityValue(value: number): WidgetDpiaV0DataGravityValues {
    return this.editorData?.data?.gravityValues?.find(g => g.value === value);
  }

  private reloadData(damageType?: DamageTypeEnum) {
    this.threat = this.editorData?.queryResponse?.threat;
    this.demage = this.editorData?.queryResponse?.demage?.filter((d) => d.type === this.currentDamageType);
    this.header = this.editorData?.header;
    this.currentNote = this.editorData?.value?.note;

    this.updateTableValue(this.editorData?.value);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.loading = true;
    if (changes.editorData) {
      this.savedDamageType = this.editorData?.value?.damageType;
      this.currentDamageType = this.editorData?.value?.damageType;
      this.reloadData();
    }
    this.invalidDamageTypeSelected = this.treatmentRiskFactors ? this.treatmentRiskFactors >= 2 : false;
    setTimeout(() => this.loading = false);
  }

  changeCellValue(currentCell?: DemageRowCol, value?: number) {
    if (!this.preview || !(this.editorData.value?.data?.length > 0)) {
      const currentData: WidgetDpiaV0ValueData[] = [];
      this.demageTableRow.forEach(row => {
        row.col.forEach(cell => {
          if (currentCell && currentCell.threatUuid === cell.threatUuid && currentCell.damageUuid === row.demage.uuid) {
            currentData.push({
              damageUuid: cell.damageUuid,
              threatUuid: cell.threatUuid,
              gravityValue: value
            } as WidgetDpiaV0ValueData);
          } else {
            currentData.push({
              damageUuid: cell.damageUuid,
              threatUuid: cell.threatUuid,
              gravityValue: cell.gravityValue
            } as WidgetDpiaV0ValueData);
          }
        });
      });
      const newValue: WidgetDpiaV0Value = {
        note: this.currentNote,
        data: currentData,
        damageType: this.currentDamageType
      };
      this.updateTableValue(newValue);
      this.changeValue.emit(newValue);
    }
  }

  openTextArea(note: string) {
    if (!this.preview) {
      const dialog = this.widgetDialogService.runTextArea(
        this.translateService.stream('LABELS.NOTE'),
        note,
        true);
      dialog.subscribe((value) => {
        this.currentNote = value;
        this.changeCellValue();
      });
    }
  }

  getColor(value: number) {
    switch (value) {
      case 5:
        return 'var(--ptHigh)';
      case 4:
        return 'var(--ptMediumHigh)';
      case 3:
        return 'var(--ptMedium)';
      case 2:
        return 'var(--ptMediumLow)';
      case 1:
        return 'var(--ptLow)';
      case 0:
        return 'var(--ptSecondary)';
    }
    return '';
  }

  changeDamageType($event: DamageTypeEnum) {
    if (this.savedDamageType) {
      this.invalidDamageTypeSelected = false;
      if ($event !== this.savedDamageType) {
        this.showConfirmChange = true;
        if ($event === DamageTypeEnum.DPIA_SIMPLIFIED && this.treatmentRiskFactors >= 2) {
          this.invalidDamageTypeSelected = true;
        }
      } else {
        this.showConfirmChange = false;
      }
    } else {
      this.currentDamageType = $event;
      this.changeDamageTypeConfirmed();
    }

  }

  changeDamageTypeConfirmed() {
    this.showConfirmChange = false;

    const newValue: WidgetDpiaV0Value = {
      note: this.currentNote,
      data: [],
      damageType: this.currentDamageType
    };
    this.savedDamageType = this.currentDamageType;
    this.reloadData();
    // this.changeCellValue();
    //
    this.updateTableValue(newValue);
  }

  changeDamageTypeCancel() {
    this.currentDamageType = this.savedDamageType;
    this.showConfirmChange = false;
  }

  getRiskFactorColor(riskFactor: number) {
    if (riskFactor || riskFactor === 0) {
      return riskFactor > 0.1 ? 'text-danger' : 'text-success';
    }
    return '';
  }

  showRiskFactor(riskFactor: number) {
    return riskFactor || riskFactor === 0;
  }

  private updateTableValue(tableValue: WidgetDpiaV0Value) {
    if (this.savedDamageType) {
      this.value = tableValue ? JSON.parse(JSON.stringify(tableValue)) : null;
      let updateValue = false;
      this.demageTableRow = [];
      this.demage?.forEach((currentDemage: WidgetDpiaV0QueryResponseDemage) => {
        if (currentDemage.type === this.currentDamageType) {
          const currentCol: DemageRowCol[] = [];
          this.threat?.forEach((currentThreat: WidgetDpiaV0QueryResponseThreat) => {
            const currentValue = this.value?.data.find((d) => d.damageUuid === currentDemage.uuid && d.threatUuid === currentThreat.uuid);
            if (currentValue) {
              currentCol.push({
                damageUuid: currentValue.damageUuid,
                threatUuid: currentThreat.uuid,
                gravityValue: currentValue.gravityValue
              });
            } else {
              updateValue = true;
              currentCol.push({
                damageUuid: currentDemage.uuid,
                threatUuid: currentThreat.uuid,
                gravityValue: this.editorData.data.defaultGravityValue
              });
            }
          });
          this.demageTableRow.push({
            demage: currentDemage,
            col: currentCol
          } as DemageRow);
        }
      });
      if (updateValue) {
        this.changeCellValue();
      }
    }
  }
}


interface DemageRow {
  demage: WidgetDpiaV0QueryResponseDemage;
  col: DemageRowCol[];
}

interface DemageRowCol {
  damageUuid: string;
  threatUuid: string;
  gravityValue: number;
}
